import Form from '@appComponents/ReduxFormControls';
import {BASE_FORM_MESSAGES} from '@constants/messages';
import {SPIIDEO_STADIUM_MAPPING} from '@constants/resources';
import {REQUIRE_THREE_LETTERS_PLACEHOLDER} from '@constants/variables';
import {
    CreateSpiideoStadiumMapping,
    DeleteSpiideoStadiumMapping,
    UpdateSpiideoStadiumMapping,
} from '@graphql/spiideoStadiumMapping/mutation';
import {GetSpiideoStadiumMappingForForm} from '@graphql/spiideoStadiumMapping/query';

import validate from './validator';

export default function SpiideoVenueMappingModel() {
    return {
        entityDataMapKey: 'spiideoStadiumMapping',
        entityLabel: 'Spiideo venue mapping',
        formName: 'spiideoStadiumMapping',
        label: 'Spiideo venue mapping',
        resources: SPIIDEO_STADIUM_MAPPING,
        showChangeLog: true,
        validate: validate,
        title: null,
        dataMap: {
            spiideoStadiumMapping: {
                id: '',
                stadium: null,
                spiideo_scene_uuid: '',
            },
        },
        messages: {
            boxName: {
                delete: 'spiideoVenueMappingMessage',
                error: 'spiideoVenueMappingMessageError',
                success: 'spiideoVenueMappingMessage',
            },
            text: {...BASE_FORM_MESSAGES},
        },
        fields: {
            id: {
                component: Form.IdField,
                dataMapKey: 'spiideoStadiumMapping.id',
                props: {
                    hidden: true,
                    label: '',
                    name: 'id',
                },
            },
            stadium: {
                dataMapKey: 'spiideoStadiumMapping.stadium.id',
                props: {
                    className: '--long-width',
                    component: Form.SemanticSelect,
                    label: 'Venue',
                    name: 'stadium',
                    required: true,
                    placeholder: REQUIRE_THREE_LETTERS_PLACEHOLDER,
                },
            },
            spiideo_scene_uuid: {
                dataMapKey: 'spiideoStadiumMapping.spiideo_scene_uuid',
                props: {
                    className: '--long-width',
                    component: Form.SemanticInput,
                    label: 'Spiideo scene UUID',
                    name: 'spiideo_scene_uuid',
                    required: true,
                    type: 'input',
                    maxLength: 36,
                },
            },
        },
        mutation: {
            createEntity: CreateSpiideoStadiumMapping,
            deleteEntity: DeleteSpiideoStadiumMapping,
            updateEntity: UpdateSpiideoStadiumMapping,
        },
        query: {
            getEntity: GetSpiideoStadiumMappingForForm,
        },
    };
}
